module.exports = __webpack_public_path__ + "img/pic_features_1.f9c64454.png";